<template>
    <div class="count">
        <div class="label">
            设备统计总量
        </div>
        <div v-if="Data && Data.data0">
            <el-row :gutter="20">
                <el-col :span="12">
                    <div style="margin-top: 20px;position: relative;">
                        <img src="/static/images/home/count/bg.png" alt="">
                        <div style="left: 0;top: 0;position: absolute;width: 100%;height: 100%;text-align: center;">
                            <div style="font-size: 20px;font-weight: bold;color: #fff;padding-top: 30px;">
                                设备总数</div>
                            <div
                                style="padding-top: 20px;line-height: 1;font-size: 40px;letter-spacing: 2px;color: #ef9d27;font-weight: bold;">
                                {{Data.data0.num0}}
                            </div>
                        </div>
                    </div>
                </el-col>
                <el-col :span="12">
                    <div style="margin-top: 20px;position: relative;">
                        <img src="/static/images/home/count/bg.png" alt="">
                        <div style="left: 0;top: 0;position: absolute;width: 100%;height: 100%;text-align: center;">
                            <div style="font-size: 20px;font-weight: bold;color: #fff;padding-top: 30px;">
                                在线设备</div>
                            <div
                                style="padding-top: 20px;line-height: 1;font-size: 40px;letter-spacing: 2px;color: #ef9d27;font-weight: bold;">
                                {{Data.data0.num1}}
                            </div>
                        </div>
                    </div>
                </el-col>
                <el-col :span="12">
                    <div style="margin-top: 20px;position: relative;">
                        <img src="/static/images/home/count/bg.png" alt="">
                        <div style="left: 0;top: 0;position: absolute;width: 100%;height: 100%;text-align: center;">
                            <div style="font-size: 20px;font-weight: bold;color: #fff;padding-top: 30px;">
                                故障设备</div>
                            <div
                                style="padding-top: 20px;line-height: 1;font-size: 40px;letter-spacing: 2px;color: #ef9d27;font-weight: bold;">
                                {{Data.data0.num2}}
                            </div>
                        </div>
                    </div>
                </el-col>
                <el-col :span="12">
                    <div style="margin-top: 20px;position: relative;">
                        <img src="/static/images/home/count/bg.png" alt="">
                        <div style="left: 0;top: 0;position: absolute;width: 100%;height: 100%;text-align: center;">
                            <div style="font-size: 20px;font-weight: bold;color: #fff;padding-top: 30px;">
                                租赁到期</div>
                            <div
                                style="padding-top: 20px;line-height: 1;font-size: 40px;letter-spacing: 2px;color: #ef9d27;font-weight: bold;">
                                {{Data.data0.num3}}
                            </div>
                        </div>
                    </div>
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
    import {
        UserStore
    } from '@/utils/Mixin'
    export default {
        mixins: [UserStore]
    }
</script>

<style>
    .label {
        font-size: 16px;
        color: #18A1DF;
    }

    .count {
        padding: 20px;
        background-image: url("/static/images/new/bg-b.png");
        background-size: cover;
    }
</style>
